
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91token_93X_SNIr30V3Bm0EOkw3WqD0f5kY7DeV01Qh92Gxzb0lAMeta } from "/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/invitation/[token].vue?macro=true";
import { default as auto_45positionnement8720VmPMaWo_5f1ub72mpdXLXD9OXGXeKMuztNgOFK0Meta } from "/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/auto-positionnement.vue?macro=true";
import { default as _91meetingId_93NsqiId6DcOFpM2JILtUPCc6qF8qnUiOXyBbBa__BVZQMeta } from "/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId].vue?macro=true";
import { default as indexCU__DKa8Puhf0P_3BxRDduOLRMJlH4_d3iH7fbjzTx4Meta } from "/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/index.vue?macro=true";
export default [
  {
    name: "auth-password-reset",
    path: "/auth/password/reset",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/auth/password/reset.vue")
  },
  {
    name: "auth-complete",
    path: "/auth/complete",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/auth/complete.vue")
  },
  {
    name: "auth-intrassoc",
    path: "/auth/intrassoc",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/auth/intrassoc.vue")
  },
  {
    name: "gestionnaire-en-cours",
    path: "/gestionnaire/en-cours",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/gestionnaire/en-cours.vue")
  },
  {
    name: "gestionnaire-my-scope",
    path: "/gestionnaire/my-scope",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/gestionnaire/my-scope.vue")
  },
  {
    name: "gestionnaire-opinion-review",
    path: "/gestionnaire/opinion-review",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/gestionnaire/opinion-review.vue")
  },
  {
    name: "gestionnaire-participants-export",
    path: "/gestionnaire/participants-export",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/gestionnaire/participants-export.vue")
  },
  {
    name: "gestionnaire-meetingId",
    path: "/gestionnaire/:meetingId()",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/gestionnaire/[meetingId]/index.vue")
  },
  {
    name: "invitation-token",
    path: "/invitation/:token()",
    meta: _91token_93X_SNIr30V3Bm0EOkw3WqD0f5kY7DeV01Qh92Gxzb0lAMeta || {},
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/invitation/[token].vue")
  },
  {
    name: _91meetingId_93NsqiId6DcOFpM2JILtUPCc6qF8qnUiOXyBbBa__BVZQMeta?.name,
    path: "/stages/:meetingId()",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId].vue"),
    children: [
  {
    name: "stages-meetingId-parametrage-formulaires-formId-apercu",
    path: "parametrage/formulaires/:formId()/apercu",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/formulaires/[formId]/apercu.vue")
  },
  {
    name: "stages-meetingId-parametrage-formulaires-formId-reponses",
    path: "parametrage/formulaires/:formId()/reponses",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/formulaires/[formId]/reponses.vue")
  },
  {
    name: "stages-meetingId-parametrage-formulaires-formId",
    path: "parametrage/formulaires/:formId()",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/formulaires/[formId]/index.vue")
  },
  {
    name: "stages-meetingId-parametrage-communication",
    path: "parametrage/communication",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/communication.vue")
  },
  {
    name: "stages-meetingId-parametrage-documents",
    path: "parametrage/documents",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/documents.vue")
  },
  {
    name: "stages-meetingId-parametrage-equipes",
    path: "parametrage/equipes",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/equipes.vue")
  },
  {
    name: "stages-meetingId-parametrage-exports",
    path: "parametrage/exports",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/exports.vue")
  },
  {
    name: "stages-meetingId-parametrage-formateurs",
    path: "parametrage/formateurs",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/formateurs.vue")
  },
  {
    name: "stages-meetingId-parametrage-formulaires",
    path: "parametrage/formulaires",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/formulaires/index.vue")
  },
  {
    name: "stages-meetingId-parametrage-modularite",
    path: "parametrage/modularite",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/modularite/index.vue")
  },
  {
    name: "stages-meetingId-parametrage-opinion-review",
    path: "parametrage/opinion-review",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/opinion-review.vue")
  },
  {
    name: "stages-meetingId-parametrage-participants",
    path: "parametrage/participants",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/participants.vue")
  },
  {
    name: "stages-meetingId-parametrage-planning",
    path: "parametrage/planning",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/planning.vue")
  },
  {
    name: "stages-meetingId-parametrage-planning-creation",
    path: "parametrage/planning-creation",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/planning-creation.vue")
  },
  {
    name: "stages-meetingId-parametrage-salles",
    path: "parametrage/salles",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/salles.vue")
  },
  {
    name: "stages-meetingId-parametrage-services",
    path: "parametrage/services",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/services.vue")
  },
  {
    name: "stages-meetingId-parametrage-tagada",
    path: "parametrage/tagada",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/tagada.vue")
  },
  {
    name: "stages-meetingId-formulaires-formId-reponse",
    path: "formulaires/:formId()/reponse",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/formulaires/[formId]/reponse.vue")
  },
  {
    name: "stages-meetingId-notes-noteId-export",
    path: "notes/:noteId()/export",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/notes/[noteId]/export.vue")
  },
  {
    name: "stages-meetingId-participants-participantId-check-in",
    path: "participants/:participantId()/check-in",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/participants/[participantId]/check-in.vue")
  },
  {
    name: "stages-meetingId-participants-participantId-view",
    path: "participants/:participantId()/:view()",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/participants/[participantId]/[view].vue")
  },
  {
    name: "stages-meetingId-documents-documentId",
    path: "documents/:documentId()",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/documents/[documentId].vue")
  },
  {
    name: "stages-meetingId-equipes-de-vie-dailyTaskTeamId",
    path: "equipes-de-vie/:dailyTaskTeamId()",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/equipes-de-vie/[dailyTaskTeamId].vue")
  },
  {
    name: "stages-meetingId-equipes-teamId",
    path: "equipes/:teamId()",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/equipes/[teamId].vue")
  },
  {
    name: "stages-meetingId-formulaires-formId",
    path: "formulaires/:formId()",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/formulaires/[formId]/index.vue")
  },
  {
    name: "stages-meetingId-participants-participantId",
    path: "participants/:participantId()",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/participants/[participantId]/index.vue")
  },
  {
    name: "stages-meetingId-auto-positionnement",
    path: "auto-positionnement",
    meta: auto_45positionnement8720VmPMaWo_5f1ub72mpdXLXD9OXGXeKMuztNgOFK0Meta || {},
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/auto-positionnement.vue")
  },
  {
    name: "stages-meetingId-documents",
    path: "documents",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/documents/index.vue")
  },
  {
    name: "stages-meetingId-emargement",
    path: "emargement",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/emargement.vue")
  },
  {
    name: "stages-meetingId-equipes",
    path: "equipes",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/equipes/index.vue")
  },
  {
    name: "stages-meetingId-formulaires",
    path: "formulaires",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/formulaires/index.vue")
  },
  {
    name: "stages-meetingId-mes-infos",
    path: "mes-infos",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/mes-infos.vue")
  },
  {
    name: "stages-meetingId-modularite",
    path: "modularite",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/modularite.vue")
  },
  {
    name: "stages-meetingId-notes",
    path: "notes",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/notes/index.vue")
  },
  {
    name: "stages-meetingId-parametrage",
    path: "parametrage",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/parametrage/index.vue")
  },
  {
    name: "stages-meetingId-participants",
    path: "participants",
    meta: {"middleware":"participants-redirect"},
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/participants/index.vue")
  },
  {
    name: "stages-meetingId-planning",
    path: "planning",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/planning.vue")
  },
  {
    name: "stages-meetingId-planning-formation",
    path: "planning-formation",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/planning-formation.vue")
  },
  {
    name: "stages-meetingId-planning-impression",
    path: "planning-impression",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/planning-impression.vue")
  },
  {
    name: "stages-meetingId-services",
    path: "services",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/services.vue")
  },
  {
    name: "stages-meetingId",
    path: "",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/stages/[meetingId]/index.vue")
  }
]
  },
  {
    name: "changelog",
    path: "/changelog",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/changelog.vue")
  },
  {
    name: "deontologie",
    path: "/deontologie",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/deontologie.vue")
  },
  {
    name: "gestionnaire",
    path: "/gestionnaire",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/gestionnaire/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/login.vue")
  },
  {
    name: "mentions",
    path: "/mentions",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/mentions.vue")
  },
  {
    name: "mes-infos",
    path: "/mes-infos",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/mes-infos.vue")
  },
  {
    name: "politique-confidentialite",
    path: "/politique-confidentialite",
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/politique-confidentialite.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexCU__DKa8Puhf0P_3BxRDduOLRMJlH4_d3iH7fbjzTx4Meta || {},
    component: () => import("/builds/sgdf/projets-benevoles/digiform/front/webapp/pages/index.vue")
  }
]